<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center">
        Position Calculator
      </div>

      <v-spacer />

      <div class="d-flex align-center">
        <v-btn
          :href="`https://gitlab.com/hodl.trade/position/-/tags/v${version}`"
          target="_blank"
          text
        >
          {{ version }}
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
      </div>
    </v-app-bar>

    <v-content>
      <Calculator v-bind:value="calc" v-on:input="saveCalc($event)" />
    </v-content>
  </v-app>
</template>

<script>
const version = require("../package.json").version;

import Calculator from "./components/Calculator";

let localStorage = window.localStorage || {};

function storageRead(key) {
  if (!localStorage) {
    return undefined;
  }

  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (e) {
    return undefined;
  }
}

function storageWrite(key, value) {
  if (!localStorage) {
    return;
  }

  localStorage.setItem(key, JSON.stringify(value));
}

export default {
  name: "App",

  components: {
    Calculator
  },

  data: () => ({
    calc: storageRead("calc"),
    version: version
  }),
  methods: {
    saveCalc(value) {
      storageWrite("calc", value);
    }
  }
};
</script>
